<template>
<v-dialog v-model="dialogAlbums" max-width="500px" persistent max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">
          <v-layout row wrap>
            <v-icon color="white">fas fa-images</v-icon>&nbsp;&nbsp;
            <p v-if="infoalbums.albums_name != '' && status == 'show'" class="mb-0">{{infoalbums.albums_name}} ({{filter_infoalbum.length}})</p>
            <p v-else-if="status == 'error'" class="mb-0">{{$t('Dialog.album.noAlbum')}}</p>
            <p v-else class="mb-0">{{date(infoalbums.create_date)}}</p>
          </v-layout>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="!edit && !edit_name && !delete_image && status != 'error'">
          <v-menu bottom offset-y>
            <v-btn dark icon flat slot="activator" row wrap>
              <v-icon style="font-size: 15px !important;">more_vert</v-icon>
            </v-btn>
            <v-list style="width: 165px;">
              <v-list-tile @click="edit = !edit">
                <v-icon style="font-size: 15px;" color="grey">fas fa-plus-circle</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnAddImage')}}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="edit_name = !edit_name">
                <v-icon style="font-size: 15px;" color="grey">fas fa-edit</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnEdit')}}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="delete_image = !delete_image">
                <v-icon style="font-size: 15px;" color="grey">far fa-trash-alt</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnRemoveImage')}}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="remove">
                <v-icon style="font-size: 15px;" color="grey">far fa-trash-alt</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">{{$t('Dialog.album.btnRemoveAlbum')}}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text style="padding-left: 30px;">
      <v-progress-linear :indeterminate="progress" v-if="status == 'progress'"></v-progress-linear>
      <div v-else-if="status == 'show'">
        <!-- modal picture -->
        <!-- <div id="myModalImageAlbums" class="modalc">
          <div id="headcaption">
            <v-container>
              <v-layout row wrap>
                <v-flex xs2 md2 sm2 style="text-align: right; padding-right: 2vw;">
                  <v-avatar class="user-photo">
                    <img v-if="picSend" :src="picSend" class="alligator-turtle">
                    <img v-else-if="typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                    <img v-else-if="typeuser === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                  </v-avatar>
                </v-flex>
                <v-flex xs9 md9 sm9>
                  <p style="font-size: 14px; white-space: nowrap; width: 16em; overflow: hidden; text-overflow: ellipsis;font-weight: bold;"> {{filenameSend}} </p>
                  <p style="font-size: 12px; white-space: nowrap; width: 20em; overflow: hidden; text-overflow: ellipsis;"> เพิ่มโดย {{nicknameSend}}
                  </p>
                  <p style="font-size: 12px;">วันที่ &nbsp;{{dateSend}} <v-icon style="font-size:7px !important; color: white !important;">schedule</v-icon>{{timeSend}}
                  </p>
                </v-flex>
                <v-flex xs1 md1 sm1>
                  <span class="close" @click="closemodal()">&times;</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md12 sm12 style="margin-left: 15vw;">
                  <v-btn depressed small  class="btnallow"  @click="loadpic(filenameSend)">
                    <v-icon>file_download</v-icon>&nbsp;
                      บันทึก
                  </v-btn>
                </v-flex>
              </v-layout>
          </v-container>
          </div>
          <img class="modal-contentc" id="imgAlbums">
      </div> -->
        <v-layout align-center justify-start row wrap v-if="filter_infoalbum.length != 0">
          <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
            <v-layout row wrap style="overflow-y:scroll!important; max-height: 45vh;">
              <v-flex v-for="(image,index) in filter_infoalbum" xs4 sm4 md4>
                <v-card flat tile>
                  <v-card-media :src="image.link" height="15vh" @click="showimagealbums(image)">
                    <v-checkbox v-model="selected" :value="{'image_id':image.id, 'index': index}" style="float: right;" color="info" v-if="delete_image"></v-checkbox>
                  </v-card-media>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
        <v-layout column wrap v-else align-center justify-center>
          <img src="/static/img/icons/image.png" width="150px">
          <h3>{{$t('Dialog.album.noImageAlbum')}}</h3>
        </v-layout>
        <div style="max-height:200px; min-height:100px; margin-top: 10px; word-break: break-all;" class="scrolling-wrapper">
          <div v-if="edit" style="width: 100%;">
            <div style="height: 190px; overflow-y: hidden; margin-top: 10px;">
              <div>
                <form ref="fileform" style="float: left;">
                  <label>
                    <b class="CSChatThai" style="text-decoration: underline; cursor: pointer;text-indent: 5em;">{{$t('AnswerQuestion.selectPicture')}}</b>
                    <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" />
                  </label>
                </form>
                <v-flex xs12 sm12 md12 v-if="files.length > 0 " style="overflow-x: scroll;overflow-y: hidden; height: 40vh !important; width: 100% !important; display: -webkit-inline-box;  padding-top: 3px;" class="containers">
                  <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
                    <a style="float: right; padding-right: 10px; font-size: 20px;" class="close-classic" @click="removeFile( key )"></a>
                    <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;">
                      <img class="preview" v-bind:ref="'preview'+parseInt( key )"
                        style="height: 18vh !important; width:20vh !important;display: flex;justify-content: center; border-radius: 10px; border-color: #8080808f; border-style: solid; border-width: thin;" />
                      <!-- <b class="text2">{{ file.file.name }}</b> -->
                    </div>
                    <div v-else style="text-align: center; display: grid; justify-content: center;">
                      <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                      <!-- <b class="text2">{{ file.file.name }}</b> -->
                    </div>
                  </div>
                </v-flex>
              </div>
            </div>
          </div>
          <div v-else-if="edit_name" style="width: 100%;">
            <v-text-field name="albumsname" :label="$t('Alert.Fail.Album.emptyName')" id="albumsname" v-model="albumsname"></v-text-field>
            <v-layout row wrap align-center justify-center>
              <v-btn class="btncancel" @click="edit_name = !edit_name">{{$t('AnswerQuestion.cancel')}}</v-btn>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <v-btn class="btnallow ml-2" @click="Edit_Name()" :loading="loading" :disabled="albumsname == ''">{{$t('AnswerQuestion.ok')}}</v-btn>
            </v-layout>
          </div>
          <!-- <p v-else style="" class="" v-html="convert(dataalbums.note_data.text ).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p> -->
        </div>
        <div>
          <v-layout align-center justify-center row wrap v-if="edit">
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-end row wrap style="padding-right: 10px;">
                <v-btn dark @click="cancel" v-if="edit" class="btncancel">{{$t('AnswerQuestion.cancel')}}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-start row wrap>
                <v-btn @click="addimage()" v-if="edit" class="btnallow" :loading="loading" :disabled="files.length == 0">{{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center row wrap v-else-if="delete_image">
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-end row wrap style="padding-right: 10px;">
                <v-btn dark @click="cancel" v-if="delete_image" class="btncancel">{{$t('AnswerQuestion.cancel')}}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-start row wrap>
                <v-btn  @click="deleteimage()" v-if="delete_image" class="btnallow" :loading="loading" :disabled="selected.length == 0">{{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-else-if="status == 'error'" style="text-align: center;">
        <br>
        <v-icon style="color: #757575 !important; font-size: 80px !important;">error_outline</v-icon>
        <br><br>
        <p style="font-size: 20px; color: #757575;"> {{errormessage}} </p>
      </div>
    </v-card-text>
  </v-card>
</v-dialog>
<!-- <v-dialog v-model="dialogAlbums" v-else></v-dialog> -->
</template>
<script>
import {
  Momenttime,
  Decode
} from '@/services'
var _ = require('lodash')
export default {
  props: {
    dialogAlbums: false,
    albums_id: ''
  },
  data: () => ({
    dataalbums: {
      note_data: {
        text: ''
      }
    },
    token: '',
    edit: false,
    edittext: '',
    preedittext: '',
    progress: true,
    status: 'show',
    errormessage: '',
    infoalbums: [],
    albumsname: '',
    files: [],
    edit_name: false,
    add_image: false,
    new_name: '',
    loading: false,
    delete_image: false,
    selected: [],
    filter_infoalbum: [],
    path_pic: '',
    picSend: '',
    nicknameSend: '',
    filenameSend: '',
    dateSend: '',
    timeSend: '',
    tokenmsgSend: '',
    pathSend: '',
    typeuserSend: '',
    image_modal: false,
    typeuser: ''
  }),
  created() {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  methods: {
    showimagealbums (image) {
      // console.log(image)
      this.$swal({
        imageUrl: image.link,
        imageHeight: 250,
        // html: '<div><img style="width: 250px; height: 250px;" src="'+ image.link + '"><button id="btn-img">test</button></div>',
        showCloseButton: true,
        showConfirmButton: false,
        confirmButtonText: this.$t('AnswerQuestion.download'),
        // cancelButtonText: 'ส่งไป Onebox',
        showCancelButton: false
      }).then((result) => {
        // console.log(result)
        if (result.value) {
          // console.log('showCloseButton')
          this.downloadimage(image.link)
        } else if (result.dismiss == 'cancel') {
          // console.log('cancelButtonText')
          // this.sendimgonebox(tokenmessage)
        }
      })
    },
    downloadimage (link) {
      var cnvs = link
      console.log(cnvs)
      var button = ''
      var dataURL = cnvs[0].toDataURL('image/png')
      button.href = dataURL
    },
    closemodal () {
      var modal = document.getElementById('myModalImageAlbums')
      modal.style.display = 'none'
    },
    dateMoment (data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment (data) {
      return Momenttime.momenttimethai(data)
    },
    zoom (item) {
      // console.log(item)
      var modal = document.getElementById('myModalImageAlbums')
      var modalImg = document.getElementById('imgAlbums')
      // console.log(modalImg)
      modal.style.display = 'block'
      modalImg.src = item.link
      this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: item.upload_by}).then((response) => {
        // console.log(response.data)
        this.picSend = response.data['user'].profilepicture
        this.nicknameSend = response.data['user'].name
        this.filenameSend = item.real_filename
        this.pathSend = item.link
        this.dateSend = this.dateMoment(item.timestamp)
        this.timeSend = this.timeMoment(item.timestamp)
      })
    },
    loadpic (filenameSend) {
      this.axios.get(this.pathSend, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    deleteimage () {
      var imageid = []
      var index_image = []
      for (var i = 0; i < this.selected.length; i++) {
        imageid[i] = this.selected[i]['image_id']
        index_image[i] = this.selected[i]['index']
      }
      // console.log(imageid)
      // console.log(index_image)
      this.loading = true
      if (this.selected.length !== 0) {
        this.axios.post(process.env.APIpub + '/delete_image_albums' , {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          albums_id: this.albums_id,
          images_id: imageid
        }).then((response) => {
          this.loading = false
          for (var i = 0; i < index_image.length; i++) {
            var index = this.selected[i]['index']
            // console.log(this.filter_infoalbum[index]['status'])
            this.filter_infoalbum[index]['status'] = 'delete'
          }
          // localStorage.setItem('albums_id', this.albums_id)
          this.filter_infoalbum = _.filter(this.filter_infoalbum, function (filter_infoalbum) { return filter_infoalbum.status === 'active' })
          this.$emit('editAlbums', {'event': 'delete_image', 'albums_id': this.albums_id, 'index_image': index_image, 'image_id': imageid})
          this.$swal('', this.$t('Alert.Success.removePhoto'), 'success')
          this.selected = []
          imageid = []
          index_image = []
          this.delete_image = false
        })
      } else {
        this.$swal('', this.$t('Alert.Fail.Album.minFiles'), 'warning')
      }
    },
    addimage () {
      let formData = new FormData()
      var lengthfile = this.files.length
      var sizealums = []
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file
        formData.append('file[]', file, file.name)
        sizealums[i] = this.files[i].file.size
        // console.log(file)
      }
      if (_.sum(sizealums)/ 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' })
        this.files = []
        this.loading = false
      } else {
        this.loading = true
        formData.append('tokenuser', this.token)
        formData.append('tokenroom', this.$route.params.roomid)
        formData.append('albums_id', this.albums_id)
        this.axios.post(process.env.APIpub + '/addimage_albums', formData).then((response) => {
          // console.log(response.data.data.image_add)
          this.loading = false
          var infoalbums = {}
          infoalbums = response.data.data.image_add
          // console.log(infoalbums)
          this.$swal('', this.$t('Alert.Success.savePhotoAlbum'), 'success')
          // this.$emit('editAlbums', {'event': 'add_image', 'albums_id': this.albums_id, 'info_albums': infoalbums})
          // console.log({'event': 'add_image', 'albums_id': this.albums_id, 'info_albums': infoalbums})
          this.files = []
          this.edit = false
          this.$emit('closeAlbums', false)
        }, () => {
          this.loading = false
          // this.$swal('', 'ไม่สามารถเพิ่มรูปภาพได้ กรุณาลองใหม่ภายหลัง', 'error')
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    Edit_Name () {
      this.new_name = this.albumsname
      this.loading = true
      this.axios.post(process.env.APIpub + '/edit_albums_name', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        albums_id: this.albums_id,
        new_name: this.new_name
      }).then((response) =>{
        // console.log(response.data)
        if (response.data.status) {
          this.loading = false
          this.$swal(
            '',
            this.$t('Alert.Success.renameAlbum'),
            'success'
          )
          this.infoalbums.albums_name = this.new_name
          this.edit_name = false
          this.$emit('editAlbums', {'event': 'edit_name', 'albums_name': this.albumsname, 'albums_id': this.albums_id})
        } else {
          this.loading = false
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        }
      }).catch(err => {
        // console.log(err)
        this.loading = false
        if (err.response.data.message === 'New albums name cannot null.') {
          this.$swal(
            '',
            this.$t('Alert.Fail.Album.emptyName'),
            'warning'
          )
        }
      })
    },
    closeDialog() {
      this.$emit('closeAlbums', false)
      this.edit = false
      this.edit_name = false
      this.delete_image = false
    },
    remove() {
      this.$swal({
        // title: '<div class="CSChatThai">คุณต้องการลบอัลบั้มนี้ใช่หรือไม่</div>',
        text: this.$t('Alert.Album.deleteAlbum'),
        type: 'warning',
        confirmButtonColor: '#2562af',
        confirmButtonText: `<div class="CSChatThai" style="font-size: 12px;">${this.$t('AnswerQuestion.ok')}</div>`,
        cancelButtonColor: '#9f9f9f',
        cancelButtonText: `<div class="CSChatThai" style="font-size: 12px;">${this.$t('AnswerQuestion.cancel')}</div>`,
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        // console.log(result.value)
        if (result.value) {
          this.axios.post(process.env.APIpub + '/delete_albums', {
            albums_id: this.albums_id,
            tokenuser: this.token,
            tokenroom: this.$route.params.roomid
          }).then((response) => {
            // console.log(response.data.status)
            if (response.data.status === 'success') {
              this.status = 'error'
              this.errormessage = this.$t('Alert.Fail.Album.removed')
              this.$emit('removeAlbums', this.albums_id)
              this.closeDialog()
            } else {
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            }
          })
        }
      })
    },
    save() {
      this.edit = false
      if (this.edittext !== this.preedittext) {
        this.dataalbums.note_data.text = this.edittext
        this.preedittext = this.edittext
        this.axios.post(process.env.APImanage + '/editnote', {
          note_id: this.note_id,
          tokenuser: this.token,
          text: this.edittext
        }).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            this.$emit('editNote', this.edittext, this.note_id)
          } else {
            // this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น ไม่สามารถแก้ไขโน๊ตนี้ได้ กรุณาลองใหม่ในภายหลัง', 'error')
            this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
          }
        }, () => {
          // this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น ไม่สามารถแก้ไขโน๊ตนี้ได้ กรุณาลองใหม่ในภายหลัง', 'error')
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    cancel() {
      this.edit = false
      this.files = []
      this.add_image = false
      this.delete_image = false
      this.edittext = this.preedittext
      this.selected = []
    },
    date(timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    time(timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    convert(msg) {
      var text = msg
      var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/\\%?=~_|!:,.;]*[-A-Z0-9+&@#/\\%=~_|])/ig
      var text1 = text.replace(/</g, '&lt;')
      var text2 = text1.replace(/>/g, '&gt;')
      var text3 = text2.replace(exp, '<a target="_blank" href="$1">$1</a>')
      var exp2 = /(^|[^/\\])(www\.[\S]+(\b|$))/gim
      var text4 = text3.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>')
      return text4
    },
    extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
      // return extension[extension.length-1]
    },
    handleFilesUpload(key) {
      let uploadedFiles = this.$refs.files.files
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        })
      }
      this.getImagePreviews(key)
      document.querySelector('#files').value = ''
    },
    removeFile(key) {
      this.files.splice(key, 1)
      this.getImagePreviews(key)
    },
    getImagePreviews(key) {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
          let reader = new FileReader()
          reader.addEventListener('load', function() {
            this.$refs['preview' + parseInt(i)][0].src = reader.result
            // console.log(this.$refs['preview' + parseInt(i)][0].src = reader.result)
          }.bind(this), false)
          reader.readAsDataURL(this.files[i].file)
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
          // this.$nextTick(function(){
          // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
          // });
          // console.log('mm')
        }
      }
    }
  },
  watch: {
    selected () {
      // console.log(this.selected)
    },
    files () {
      if (this.files.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.Album.maxFiles'),
          'warning'
        )
        _.pullAt(this.files, [5])
      }
    },
    dialogAlbums() {
      // console.log(this.albums_id)
      if (this.dialogAlbums) {
        // this.dataalbums.note_data.text = 'test'
        this.progress = true
        this.status = 'progress'
        this.axios.post(process.env.APIpub + '/get_albums', {
          albums_id: this.albums_id,
          tokenroom: this.$route.params.roomid,
          tokenuser: this.token
        }).then((response) => {
          this.progress = false
          this.status = 'show'
          // if (response.data.list_note.length !== 0) {
          this.infoalbums = response.data.data
          this.albumsname = this.infoalbums.albums_name
          // console.log(this.infoalbums.information)
          this.filter_infoalbum = _.filter(this.infoalbums.information, function (information) { return information.status === 'active' })
          // console.log(this.infoalbums)
          //   this.edittext = response.data.list_note[0].note_data.text
          //   this.preedittext = response.data.list_note[0].note_data.text
          // } else {
          //   this.progress = false
          //   this.status = 'error'
          //   this.errormessage = 'ขออภัย!! โน๊ตนี้ถูกลบแล้ว'
          // }
        }).catch((error) => {
          this.status = 'error'
          if (error.response.data.status === 'fail') {
            this.errormessage = this.$t('Alert.Fail.Album.removed')
          }
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.theme--light.v-icon {
    color: #1976d2;
}
>>>.theme--light.v-icon .v-checkbox {
    color: #2196f3 !important;
}
>>>.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100%;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
    background-color: #83b2ec !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
}

.scrolling-wrapper {
  display: flex;
  overflow-y: auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 10px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=textadd] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 12px 12px 12px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

.text2 {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  /* ANSI X letter */
}

.containers {
  width: 576px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 45vw !important;
  height: 20vh !important;
  position: relative;
  background: white;
}
/* The Modal (background) */
.modalc {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
 /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}
/* Modal Content (Image) */
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  /*width: 80%;*/
  width: auto;
  height: 50%;
}
/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}
#headcaption {
  /*margin: auto;
  display: block;
  text-align: left;
  color: white;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;*/
  margin: auto;
  display: block;
  text-align: left;
  color: #fff;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;
}
/* Add Animation - Zoom in the Modal */
/*.modal-contentc {
    animation-name: zoom;
    animation-duration: 0.6s;
}*/
@keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
}
/* The Close Button */
.close {
  top: 0;
  right: 35px;
  color: #fff;
  font-size: 25px;
  font-weight: 700;
  transition: .3s;
  margin-top: 15vh;
  /*position: absolute;
  top: 0vh;
  right: 35px;
  color: white;
  font-size: 25px;
  font-weight: 700px;
  transition: 0.3s;*/
}
.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}
/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
    .modal-contentc {
        /*width: 100vw;*/
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/AlbumsDialogMobile.vue